module.exports = __webpack_public_path__ + "img/new5.50559b01.jpg";